import React, { useEffect, useRef } from "react";
import { __ } from "services/Translator";
import MessageBubble from "support/components/MessageBubble";

// role=log + polite: new agent replies are announced without interrupting what
// the player is doing. The RG handoff is the only assertive region in the
// messenger and it lives in its own view.
export default function MessageList({ messages }) {
  const endRef = useRef(null);
  const count = messages ? messages.length : 0;

  useEffect(() => {
    if (endRef.current && endRef.current.scrollIntoView) {
      endRef.current.scrollIntoView({ block: "end" });
    }
  }, [count]);

  if (!count) {
    return <p className="supEmpty">{__("No messages yet.")}</p>;
  }

  return (
    <>
      <ul className="supMsgList" role="log" aria-live="polite" aria-label={__("Conversation")}>
        {messages.map((message) => (
          <MessageBubble key={message.id || message.tempId} message={message} />
        ))}
      </ul>
      <div ref={endRef} />
    </>
  );
}
